import { StripePlugin } from '@vue-stripe/vue-stripe';

export const STRIPE_PUBLIC_KEY = process.env.STRIPE_PUBLIC_KEY;
export const stripePlugin = StripePlugin;
export const stripeOptions = {
  pk: STRIPE_PUBLIC_KEY,
};
